// extracted by mini-css-extract-plugin
export default {"video-tutorial":"video-tutorial__O42eb","video-card":"video-card__-dEsI","play-btn":"play-btn__UzoYH","title":"title__mLxHV"};